/* Ludidoo round 9 – "Chci fakturu na firmu": keeps cart attributes firma / ico / dic / fakturacni_adresa
   in sync with every [data-ld-invoice] box (cart drawer + /cart). Saves via /cart/update.js (debounced,
   flushed on blur and before checkout). Unticking clears all four attributes. */
(function () {
  if (window.__ldInvoice) return; window.__ldInvoice = true;
  var KEYS = ['firma', 'ico', 'dic', 'fakturacni_adresa'];
  var S = null, timer = null, inflight = null, dirty = false, warned = false, bypass = false;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function boxes() { return document.querySelectorAll('[data-ld-invoice]'); }
  function norm(k, v) {
    v = (v || '').trim();
    if (k === 'ico') return v.replace(/\s+/g, '');
    if (k === 'dic') return v.replace(/\s+/g, '').toUpperCase();
    return v;
  }
  function readBox(b) {
    var s = { on: !!(b.querySelector('[data-ld-invoice-toggle]') || {}).checked };
    KEYS.forEach(function (k) { var el = b.querySelector('[data-ld-invoice-key="' + k + '"]'); s[k] = el ? el.value : ''; });
    return s;
  }
  function applyBox(b, except) {
    var t = b.querySelector('[data-ld-invoice-toggle]'), f = b.querySelector('.ld-invoice__fields');
    if (t) { t.checked = S.on; t.setAttribute('aria-expanded', S.on); }
    if (f) f.hidden = !S.on;
    b.classList.toggle('is-open', S.on);
    KEYS.forEach(function (k) {
      var el = b.querySelector('[data-ld-invoice-key="' + k + '"]');
      if (el && el !== except && el.value !== S[k]) el.value = S[k];
    });
  }
  function applyAll(except) { boxes().forEach(function (b) { applyBox(b, except); }); }

  function errors() {
    var e = {};
    if (!S.on) return e;
    if (!norm('firma', S.firma)) e.firma = 1;
    var ico = norm('ico', S.ico); if (ico && !/^\d{8}$/.test(ico)) e.ico = 1;
    var dic = norm('dic', S.dic); if (dic && !/^(CZ|SK)\d{8,10}$/.test(dic)) e.dic = 1;
    return e;
  }
  // only: limit which fields may newly show an error (blur shows its own field; checkout shows all)
  function showErrors(only) {
    var e = errors();
    boxes().forEach(function (b) {
      ['firma', 'ico', 'dic'].forEach(function (k) {
        var p = b.querySelector('[data-ld-invoice-err="' + k + '"]'); if (!p) return;
        var field = p.previousElementSibling, shown = !p.hidden;
        var show = !!e[k] && (shown || !only || only.indexOf(k) > -1);
        p.hidden = !show; p.textContent = show ? b.getAttribute('data-err-' + k) : '';
        if (field) field.classList.toggle('is-invalid', show);
        var input = b.querySelector('[data-ld-invoice-key="' + k + '"]'); if (input) input.setAttribute('aria-invalid', show);
      });
    });
    return e;
  }

  function payload() {
    var a = {};
    KEYS.forEach(function (k) { a[k] = S.on ? norm(k, S[k]) : ''; });
    return { attributes: a };
  }
  function save(keepalive) {
    clearTimeout(timer); timer = null;
    if (!dirty) return inflight || Promise.resolve();
    dirty = false;
    var body = JSON.stringify(payload());
    var run = function () {
      return fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body, keepalive: !!keepalive, credentials: 'same-origin'
      }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function (err) { dirty = true; console.warn('[ld-invoice] save failed', err); });
    };
    var p = (inflight || Promise.resolve()).then(run);
    inflight = p;
    p.then(function () { if (inflight === p) inflight = null; });
    return p;
  }
  function schedule() { dirty = true; clearTimeout(timer); timer = setTimeout(save, 700); }

  function bindNew() {
    boxes().forEach(function (b) {
      if (b.hasAttribute('data-ld-bound')) return;
      b.setAttribute('data-ld-bound', '');
      if (!S) S = readBox(b); else { applyBox(b); if (Object.keys(errors()).length) showErrors([]); }
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target; if (!t.matches || !t.matches('[data-ld-invoice-toggle]')) return;
    if (!S) S = readBox(t.closest('[data-ld-invoice]'));
    S.on = t.checked; warned = false;
    if (!S.on) KEYS.forEach(function (k) { S[k] = ''; });
    applyAll(); showErrors([]);
    dirty = true; save();
    if (S.on) { var f = t.closest('[data-ld-invoice]').querySelector('[data-ld-invoice-key="firma"]'); if (f) setTimeout(function () { f.focus(); }, 30); }
  });
  document.addEventListener('input', function (e) {
    var t = e.target, k = t.getAttribute && t.getAttribute('data-ld-invoice-key'); if (!k || !S) return;
    S[k] = t.value; applyAll(t); showErrors([]); schedule();
  });
  document.addEventListener('focusout', function (e) {
    var t = e.target, k = t.getAttribute && t.getAttribute('data-ld-invoice-key'); if (!k || !S) return;
    var n = norm(k, t.value);
    if (k !== 'fakturacni_adresa' && n !== t.value) { t.value = n; S[k] = n; applyAll(); dirty = true; }
    var only = (t.value && k !== 'fakturacni_adresa') ? [k] : [];
    // Firma is required: flag it once the customer has left it empty and filled anything else.
    if (!norm('firma', S.firma) && (S.ico || S.dic || S.fakturacni_adresa)) only.push('firma');
    showErrors(only);
    save();
  });

  // Before checkout: flush the pending save; on invalid data warn once (the next click goes through).
  // Window capture phase, because the checkout button is also handled by other scripts (Globe etc.)
  // that navigate to /checkout themselves instead of submitting the form.
  function guard(e, btn, resume) {
    if (bypass || !S || !btn) return;
    var bad = S.on ? Object.keys(showErrors(null)) : [];
    if (bad.length && !warned) {
      e.preventDefault(); e.stopImmediatePropagation(); warned = true;
      var scope = btn.closest('cart-drawer, .cart__footer') || document;
      var box = scope.querySelector('[data-ld-invoice]') || document.querySelector('[data-ld-invoice]');
      var el = box && box.querySelector('[data-ld-invoice-key="' + bad[0] + '"]');
      if (el) { el.scrollIntoView({ block: 'center', behavior: 'smooth' }); el.focus({ preventScroll: true }); }
      save();
      return;
    }
    if (dirty || timer || inflight) {
      e.preventDefault(); e.stopImmediatePropagation();
      dirty = dirty || !!timer;
      save().then(function () {
        bypass = true;
        try { resume(); } finally { setTimeout(function () { bypass = false; }, 0); }
      });
    }
  }
  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"], #CartDrawer-Checkout, #checkout');
    if (!btn || btn.disabled) return;
    guard(e, btn, function () { btn.click(); });
  }, true);
  window.addEventListener('submit', function (e) {
    var btn = e.submitter, form = e.target;
    if (!btn || btn.name !== 'checkout') return;
    guard(e, btn, function () { form.requestSubmit ? form.requestSubmit(btn) : form.submit(); });
  }, true);
  // Enter in a one-line field moves to the next field instead of submitting the cart to checkout.
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (e.key !== 'Enter' || !t.matches || !t.matches('input[data-ld-invoice-key]')) return;
    e.preventDefault();
    var all = [].slice.call(t.closest('[data-ld-invoice]').querySelectorAll('[data-ld-invoice-key]'));
    var next = all[all.indexOf(t) + 1]; if (next) next.focus(); else t.blur();
  });
  addEventListener('pagehide', function () { if (dirty || timer) { dirty = true; save(true); } });

  var mt;
  function init() {
    bindNew();
    new MutationObserver(function () { cancelAnimationFrame(mt); mt = requestAnimationFrame(bindNew); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
